import React, { useState } from 'react';
import { Table, TableColumn } from '@/components/Table/Table';
import styles from './InvoiceTable.module.css';
import Button from '@/components/forms/Button/Button';

import StatusBadge from '@/components/StatusBadge/StatusBadge';
import Pagination from '@/components/Pagination/Pagination';
import IconExport from '@/components/icons/IconExport';
import { type Invoice } from '@boxem/core-api-schema';


// const sampleInvoices = [
//     {
//       id: '1',
//       invoiceNumber: '10416',
//       issuedOn: 'March 25,2025',
//       dueOn: 'March 25,2025',
//       status: 'Paid',
//       total: 0.00,
//       currency: 'USD',
//       downloadUrl: '/invoices/10416.pdf'
//     },
//     {
//       id: '2',
//       invoiceNumber: '10416',
//       issuedOn: 'February 25,2025',
//       dueOn: 'February 25,2025',
//       status: 'Paid',
//       total: 0.00,
//       currency: 'USD',
//       downloadUrl: '/invoices/10416.pdf'
//     },
//     {
//       id: '3',
//       invoiceNumber: '10416',
//       issuedOn: 'January 25,2025',
//       dueOn: 'January 25,2025',
//       status: 'Paid',
//       total: 0.00,
//       currency: 'USD',
//       downloadUrl: '/invoices/10416.pdf'
//     },
//     {
//       id: '4',
//       invoiceNumber: '10416',
//       issuedOn: 'December 25,2024',
//       dueOn: 'December 25,2024',
//       status: 'Paid',
//       total: 0.00,
//       currency: 'USD',
//       downloadUrl: '/invoices/10416.pdf'
//     },
//     {
//       id: '5',
//       invoiceNumber: '10416',
//       issuedOn: 'November 25,2024',
//       dueOn: 'November 25,2024',
//       status: 'Paid',
//       total: 0.00,
//       currency: 'USD',
//       downloadUrl: '/invoices/10416.pdf'
//     },
//   ];



export default function InvoiceTable({ 
  invoices, 
  isLoading = false,
  onDownload = (invoice: Invoice) => {},
  onView = (invoice: Invoice) => {}
}) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };
  
  const handlePageSizeChange = (newLimit: number) => {
    setLimit(newLimit);
    setPage(1); // Reset to first page when changing page size
  };
  
  const columns = [
    {
      title: 'Invoice',
      dataKey: 'number',
      id: 'invoice',
    //   sortable: true,
      // alignment: 'left',
      renderRowCell: (row) => (
        <span 
          className={styles.invoiceNumber} 
          onClick={() => onView(row.rowData)} 
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
        >
          #{row.getCellData('number')}
        </span>
      )
    },
    {
      title: 'Issued On',
      dataKey: 'issuedOn',
      id: 'issuedOn',
    //   sortable: true,
    //   width: '12rem',
      // alignment: 'left',
    },
    {
      title: 'Due On',
      dataKey: 'dueOn',
      id: 'dueOn',
    //   sortable: true,
    //   width: '12rem',
      // alignment: 'left',
    },
    {
      title: 'Status',
      dataKey: 'status',
      id: 'status',
    //   sortable: true,
    //   width: '8rem',
      // alignment: 'left',
      renderRowCell: (row) => {
        const status = row.getCellData('state');
        return status;
      }
    },
    {
      title: 'Total',
      dataKey: 'total',
      id: 'total',
    //   sortable: true,
    //   width: '10rem',
      // alignment: 'left',
      renderRowCell: (row) => (
        <span>
          ${row.getCellData('total').toFixed(2)} {row.getCellData('currency')}
        </span>
      )
    },
    {
      title: '',
      dataKey: '',
      id: 'actions',
    //   sortable: false,
    //   width: '4rem',
      // alignment: 'right',
      renderRowCell: (row) => {
        return (
          <Button 
            type="text" 
            onClick={() => {
              onDownload(row.rowData);
            }}
            aria-label="Download invoice"
          >
            <IconExport />
          </Button>
        );
      }
    }
  ];

  // Calculate pagination
  const totalInvoices = invoices.length;
  const paginatedInvoices = invoices.slice((page - 1) * limit, page * limit);
  
  return (
    <div className={styles.invoicesTableContainer}>
      <Table
        data={paginatedInvoices}
        columns={columns}
        tableName="invoices-table"
        isLoading={isLoading}
        skeletonRows={limit}
        showSort
        header={<h2 className={styles.tableTitle}>Invoices</h2>}
        headerControls={false}
        footer={
          <Pagination
            total={totalInvoices}
            pageSize={limit}
            onChangePageSize={handlePageSizeChange}
            page={page}
            onChangePage={handlePageChange}
            showPageSelector={false}
            pageSizeOptions={[5, 10, 20]}
          />
        }
      />
    </div>
  );
}